import { React, useEffect } from "react";
import {
  AlignRightOutlined,
  BellOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import imgLogo from "../../assets/images/logo-arabica.svg";
import { Dropdown } from "antd";
import { PATHS } from "../../layout/path/Path";
import { removeData } from "../../utils/localStorage";
import { useLocation } from "react-router-dom";

export default function Header({ toggleCollapsed, collapsed }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const handleLogout = () => {
    removeData("token");
    navigate(PATHS.LOGIN);
  };

  const items = [
    {
      key: "1",
      label: (
        <div className="logout" onClick={handleLogout}>
          Logout
        </div>
      ),
    },
  ];

  return (
    <ContainerHeader>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div className="collapsed" onClick={toggleCollapsed}>
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </div>
        <img src={imgLogo} alt="logo" height={40} className="logo" />
      </div>
      <div className="icon">
        <AlignRightOutlined />
      </div>
      <input
        type="text"
        id="search-field"
        placeholder="Search for anything"
        className="form-controls"
        tabIndex="1"
      />
      <div className="header-right">
        <BellOutlined />
        <Dropdown menu={{ items }} arrow>
          <UserOutlined />
        </Dropdown>
      </div>
    </ContainerHeader>
  );
}

const ContainerHeader = styled.div`
  padding: 0 2rem;
  background-color: white;
  box-shadow: 0px 0px 28px 0px rgba(86, 61, 124, 0.13);
  display: flex;
  height: 4.125rem;
  position: fixed;
  width: 100vw;
  z-index: 9999;
  order: 1;
  padding-left: calc(2rem + 256px);

  .collapsed {
    display: none;
  }

  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto 0;
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translate(0%, -50%);
  }

  .icon {
    margin: auto 0;
    padding: 5px 11px;
    border-radius: 4px;
    border: 1px solid gainsboro;
    cursor: pointer;

    &:hover {
      background-image: linear-gradient(
        270deg,
        rgba(51, 148, 225, 0.18),
        transparent
      );
      background-color: #9885b6;
      transition: 0.3s ease-in-out;

      svg {
        color: white;
      }
    }
  }

  .icon svg {
    font-size: 20px;
  }

  #search-field {
    border: none;
    width: 70%;
    padding-left: 30px;
  }
  @media (max-width: 1199px) {
    .icon,
    #search-field {
      display: none;
    }
  }

  .header-right {
    z-index: 9999 !important;
    position: absolute;
    right: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    svg {
      font-size: 20px;
      cursor: pointer;
      color: #2c3a47;
    }

    .anticon-user {
      margin-left: 20px;
      padding: 5px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #2c3a47;
      svg {
        color: white;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 0 1rem;

    .collapsed {
      display: block;

      svg {
        font-size: 18px;
      }
    }

    .header-right {
      right: 20px;
    }

    .logo {
      left: 45px;
    }
  }
`;
